<template>
<v-chip label large class="mx-1 px-1" :color="color" :text-color="colorContrast" @click="click">
    <table>
        <tr><td>{{$td('features', name)}}</td></tr>
        <tr><td>{{formatIO(attrs.value)}}</td></tr>
    </table>
</v-chip>
</template>

<script>
import { formatIO, colorIO, contrastColorString } from '@/services/Utils.js';
import EspecChamberApi from '@/services/EspecChamberApi.js';

export default {
    props: {
        name: {type: String, required: true},
        attrs: {type: Object, required: true},
    },
    data: () => ({
        showMenu: false,
    }),
    computed: {
        color () { return colorIO(this.attrs.value, 'secondary'); },
        colorContrast () {
            const theme = this.$vuetify.theme.dark ? this.$vuetify.theme.themes.dark : this.$vuetify.theme.themes.light;
            return contrastColorString(theme[this.color] || this.color);
        }
    },
    methods: {
        click() {
            if (this.$store.getters['auth/hasRole']('features', true)) {
                const data = {value: !this.attrs.value}
                EspecChamberApi.putFeature(this.name, data)
                .then(r => this.$store.commit('features/updateByKey', r));
            }
        },
        formatIO,
        colorIO
    }
}
</script>